import React from "react";
import { t } from "../../utils/i18n";

const Preview = ({
  amount,
  sourceCurrency,
  fees,
  destinationCurrency,
  destinationAmount
}) => (
  <div className="preview-wrapper">
    <h4>{t("transfers_convert.common.review_transfer_details")}</h4>
    <hr />
    <div className="px-md-5 mx-2">
      <div className="row subtotal">
        <div className="col-md-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_convert.common.amount")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_convert.common.subtotal_crypto")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small
              id="netAmountHelpBlock"
              className="form-text text-muted"
            ></small>
          </div>{" "}
        </div>
        <div className="col-md-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0">
                  {sourceCurrency == "USDT" ? "$" : sourceCurrency}
                </div>
              </div>
              <input
                className="form-control border-0"
                placeholder="0.00"
                data-target="cryptoTransfer.outputNetAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={amount}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="row fees">
        <div className="col-md-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_convert.common.fee")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_convert.common.fees_crypto")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small id="feesHelpBlock" className="form-text text-muted"></small>
          </div>{" "}
        </div>
        <div className="col-md-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0">
                  {sourceCurrency == "USDT" ? "$" : sourceCurrency}
                </div>
              </div>
              <input
                className="form-control border-0"
                placeholder={t("transfers_convert.common.tbd")}
                data-target="cryptoTransfer.outputFeesAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={parseFloat(fees).toFixed(7)}
              />
            </div>
          </div>{" "}
        </div>
      </div>
      <div className="row total">
        <div className="col-5">
          <div className="form-group row d-block ">
            <label className="form-label">
              {t("transfers_convert.common.total")}
              <a
                data-toggle="tooltip"
                className="btn btn-link"
                data-original-title={t("transfers_convert.common.total")}
              >
                <i className="fa fa-info-circle"></i>
              </a>
            </label>
            <small
              id="netAmountHelpBlock"
              className="form-text text-muted"
            ></small>
          </div>{" "}
        </div>
        <div className="col-7">
          <div className="form-group row ">
            <div className="input-group mb-2 mr-sm-2">
              <div className="input-group-prepend">
                <div className="input-group-text selected-currency border-0 pr-0">
                  {destinationCurrency}
                </div>
              </div>
              <input
                className="form-control border-0"
                placeholder={t("transfers_convert.common.tbd")}
                data-target="cryptoTransfer.outputNetAmount"
                required="required"
                readOnly="readonly"
                type="number"
                value={parseFloat(destinationAmount).toFixed(7)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Preview;
